(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const el = document.querySelector('.related-products[data-url]');
  if (el && !el.querySelector('.product-card a')) {
    const url = el.dataset.url;
    if (url) {
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const next = doc.querySelector('.related-products');
          if (next && next.querySelector('.product-card')) {
            el.innerHTML = next.innerHTML;
          }
        })
        .catch(() => {});
    }
  }

  } catch(e) { console.error(e); }
})();
})();
